<template>
  <div>
    <Modal v-if="show" :show="show" @close="show = false">
      <div class="component">
        <h5 class="component-title">Solution notes</h5>
        <p class="component-paragraph">
          Update notes for this Solution:
          <br />
          <strong>{{ solution.name }}</strong>
        </p>

        <label for="note">Note</label>
        <textarea
          type="text"
          class="form-control"
          id="note"
          name="note"
          rows="5"
          v-model="solution.notes"
        />
        <div class="component-button">
          <input
            type="button"
            class="btn btn-outline-secondary"
            value="Cancel"
            @click="clickedCancel"
          />
          <input
            type="submit"
            class="btn btn-secondary"
            value="Save"
            :disabled="saveDisabled"
            @click="clickedSave"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "NoteSolutionModal",
  data() {
    return {
      show: true,
      solution: this.initialSolution
    };
  },
  props: ["initialSolution"],
  methods: {
    clickedSave() {
      if (this.saveDisabled) return;
      this.$emit("onSaveSolution", this.solution);
      this.show = false;
    },
    clickedCancel() {
      this.show = false;
    }
  },
  computed: {
    saveDisabled() {
      return !this.solution.notes; //cast to boolean
    }
  }
};
</script>

<style lang="scss" scoped>
.component {
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  .component-title {
    color: $blue;
    font-family: $font-family-sans-serif;
    font-weight: $btn-font-weight;
  }
  .component-paragraph {
    font-size: 16px;
  }
  .form-control {
    margin: 0 0 30px 0;
  }
  .component-button {
    margin-top: auto;
    display: flex;
    input {
      width: 100%;
      margin: 0 20px 0 0;
      &:last-of-type {
        margin: 0;
      }
    }
  }
}
</style>
